module.exports = __webpack_public_path__ + "img/dot@2x.17cbcce0.png";